<template>
  <q-card flat bordered class="q-pa-sm">
    <div
      class="text-body text-weight-bold q-pb-sm text-center"
      :class="this.$q.dark.mode === true ? '' : ' text-primary'"
    >
      Level Alert of {{ mappedArray[0]?.symbol }}
      <span class="text-primary text-body2">
        ({{ mappedArray[0]?.date }})
      </span>
    </div>

    <div v-if="mappedArray">
      <q-list bordered separator>
        <q-item>
          <ul style="margin: 0px; padding: 4px">
            <li v-for="(value, key) in mappedArray[0]?.message" :key="key">
              <span
                :style="
                  key.slice(-1) === 'n' ? { color: 'red' } : { color: 'green' }
                "
              >
                {{ value }}
              </span>
            </li>
          </ul>
        </q-item>

        <q-separator />
      </q-list>
    </div>
    <div v-else class="q-pa-md">No Data Found</div>
  </q-card>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { LocalStorage, useQuasar } from "quasar";

import { useStore } from "vuex";
import useData from "src/use/data";
import useLevelalert from "src/use/levelalert";

export default {
  name: "keyValueAlertStockWise",
  props: {
    symbol: {
      type: String,
      default: "NEPSE",
    },
  },

  setup(props) {
    const store = useStore();
    const { LevelAlertIndicatorsSymbolwise, LevelAlertIndicatorsDatewise } =
      useLevelalert();

    const $q = useQuasar();

    const listCardData = ref([]);
    const resultData = ref([]);
    const sortedresultData = ref([]);
    const symbol = ref(null);

    const LevelAlertDataSymboleWise = ref([]);
    const mappedArray = ref([]);

    function loadKeyValueData(symbol) {
      //   $q.loading.show({});
      LevelAlertIndicatorsSymbolwise(symbol)
        .then((res) => {
          LevelAlertDataSymboleWise.value = res.data;

          mappedArray.value = LevelAlertDataSymboleWise.value.map((item) => {
            let { id, date, symbol, ...message } = item;
            return { id, date, symbol, message };
          });

          //   $q.loading.hide({});
        })
        .catch((err) => {
          //   $q.loading.hide({});
        })
        .finally(() => {
          // $q.loading.hide();
        });
    }

    onMounted(() => {
      if (props.symbol) loadKeyValueData(props.symbol);
    });

    watch(props, (newProps, oldProps) => {
      loadKeyValueData(newProps.symbol);
    });
    return {
      resultData,
      sortedresultData,

      loadKeyValueData,
      mappedArray,
    };
  },
};
</script>
